import React from "react";
import { Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import TopBar from "./components/TopBar";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./auth/AuthProvider";

import Login from "./features/auth/Login";
import BlogList from "./features/blog/BlogList";
import EventMediaList from "./features/eventmedia/EventMediaList";
import CareerList from "./features/career/CareerList";
import WebSolutionsList from "./features/websolutions/WebSolutionsList";
import ServicesAdmin from "./features/services/ServicesAdmin";
import ProductsAdmin from "./features/products/ProductsAdmin";
import TeamList from "./features/team/TeamList";
import TestimonialsAdmin from "./features/testimonials/TestimonialsAdmin";
import PartnersAdmin from "./features/partners/PartnersAdmin";

 
import ClientsAdmin from "./features/clients/ClientsAdmin";

function AdminShell() {
  return <Outlet />;
}

export default function App() {
  const location = useLocation();
  const HIDE_TOPBAR_ROUTES = ["/login"];
  const showTopBar = !HIDE_TOPBAR_ROUTES.includes(location.pathname);

  return (
    <AuthProvider>
      <div style={{ minHeight: "100vh", background: "#f7f7fb" }}>
        {showTopBar && <TopBar />}

        <Routes>
          {/* Login */}
          <Route path="/login" element={<Login />} />

          {/* Protected admin area */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminShell />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="blog" replace />} />
            <Route path="blog" element={<BlogList />} />
            <Route path="event-media" element={<EventMediaList />} />
            <Route path="careers" element={<CareerList />} />
            <Route path="web-solutions" element={<WebSolutionsList />} />
            <Route path="services" element={<ServicesAdmin />} />
            <Route path="products" element={<ProductsAdmin />} />
            <Route path="team" element={<TeamList />} />
            <Route path="testimonials" element={<TestimonialsAdmin />} />
            <Route path="partners" element={<PartnersAdmin />} />

            
            <Route path="clients" element={<ClientsAdmin />} />
          </Route>

          {/* Root redirects */}
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}
